import * as React from "react";
import { useSnackbar, VariantType } from "notistack";
import "./style.css";

// internal ref to the snackbar API
let enqueueSnackbarRef: ((msg: string, options?: { variant?: VariantType }) => void) | null = null;

const setEnqueueSnackbarRef = (
  enqueueSnackbar: (msg: string, options?: { variant?: VariantType }) => void
) => {
  enqueueSnackbarRef = enqueueSnackbar;
};

/**
 * Component used once under a SnackbarProvider to capture the hook and expose it globally.
 */
export const DasSnackbar: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    setEnqueueSnackbarRef(enqueueSnackbar);
  }, [enqueueSnackbar]);

  return null;
};

/**
 * Public API
 */
const toast = (msg: string, variant: VariantType = "default") => {
  if (!enqueueSnackbarRef) {
    // optional: fallback / warning
    // eslint-disable-next-line no-console
    console.warn("Snackbar not initialized yet.");
    return;
  }
  enqueueSnackbarRef(msg, { variant });
};

const success = (msg: string) => toast(msg, "success");
const warning = (msg: string) => toast(msg, "warning");
const info = (msg: string) => toast(msg, "info");
const error = (msg: string) => toast(msg, "error");

export default {
  success,
  warning,
  info,
  error,
  toast, // still exposed if you need custom variant or default
};
